import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  leadFollowUpTitle: '{{propertyType}} {{section}} في {{location}}',
  leadFollowUpDescription:
    'لاهتمامك بـ{{propertyType}} {{section}} في {{location}} اخترنا لك أبرز الشركات العقارية في المنطقة، اطلب التواصل وسيتواصل معك اكبر الشركات العقارية بالعروض المتاحة.',
  leadFollowUpTopSellersTitle: 'اكبر الشركات العقارية',
  leadFollowUpRelatedListingsTitle: 'اعلانات ذات صلة',
  leadFollowUpListingsUnit: 'اعلان',
  leadFollowUpRequestCall: 'طلب اتصال',
  leadFollowUpCallRequested: 'تم طلب الاتصال',
});
